import { render, staticRenderFns } from "./RelationEdit.vue?vue&type=template&id=0886099c&"
import script from "./RelationEdit.vue?vue&type=script&lang=js&"
export * from "./RelationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports